import { useContext, useEffect,useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Alert, Container, Grid, LinearProgress, Stack, Typography } from "@mui/material";
import { CasUserContext } from "../../services/casUserContext";
import { TblProductoProdTermin, setProductoTerminado } from "../../interfaces/TblProductoProdTermin";
import { ProductoColaboradorDTO, getVoidProductoColaboradorDTO, setListProductoColaborador } from "../../interfaces/ColaboradorProdcutoDTO";
import { TblDecInvMotivoProdTermin, setProductoMotivo } from "../../interfaces/TblDecInvMotivoProdTermin";
import ProductoService from "../../services/ProductoService";
import UsuarioService from "../../services/UsuarioService";
import { UnauthorizedPage } from "../Error/ErrorUnauthorized";
import { FaUserPlus } from "react-icons/fa";
import { MdDoNotDisturbAlt } from "react-icons/md";
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from "../../interfaces/ProductoTerminadoDTO";
import {format} from 'date-fns';
import TableColProducto from "../../componentes/Productos/ColaboradoresProducto";
import ColProductoForm from "../../componentes/Productos/ColProductoForm";
import EmailService from "../../services/EmailService";
import { EmailModel, EmailProductoCreado, GetVoidEmailModel, setEmailProductoCreado } from "../../interfaces/MailModel";
import { RolColaboradorProducto } from "../../services/CatalogService";
import { GetVoidProyectoDatosGenerales, ProyectoDatosGenerales } from "../../interfaces/ProyectosDatosGenerales";
import ProyectoService from "../../services/ProyectoService";
import { DatosGenerales, setDatosGenerales } from "../../interfaces/DatosGenerales";
import AlertService from "../../services/AlertService";

const productoService = new ProductoService();
const proyectoService = new ProyectoService();
const usuarioService = new UsuarioService();
const emailService = new EmailService();
const alertaService = new AlertService();

export const AddColProductoPage: React.FC<{}> = () =>{
    //Seccion variables
    let {id} = useParams();
    const casUserContext = useContext(CasUserContext);
    const token = casUserContext.token;
    const user = casUserContext.userData;
    const [ready,setReady] = useState(false);
    const [datosProducto,setDatosProducto] = useState<ProductoTerminadoDTO>(()=> getVoidProdcutoTerminadoDTO());
    const [datosColaborador,setDatosColaborador] = useState<ProductoColaboradorDTO>(()=> getVoidProductoColaboradorDTO());
    const [datosGeneralProy,setDatosGeneralProy] = useState<ProyectoDatosGenerales>(()=> GetVoidProyectoDatosGenerales());
    const[auth,setAuth] = useState(false);
    const[puedo,setPuedo] = useState(false);
    const [idcreador,setIdcreador] = useState(0)
    let history = useNavigate();
    //#region Seccion de carga
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        //console.log(user);
        setAuth(flag);
        if(flag){  
          fetchData();
        }
    },[]);
    useEffect(() => {
        const flag = usuarioService.authorized(user.roles);
        //console.log(user);
        setAuth(flag);
        if(flag){  
          fetchData();
        }
    },[token]);
    //#endregion
    //#region Funciones
    const fetchData = async () =>{
        let idProy = 0;
        try{
             await productoService.GetProductoTerminadoById(parseInt(id || '0'),token)
             .then((data) => {
                //console.log(user);
                setProducto(data)
                idProy = data.data.producto.iddecinvproyecto;
             })               
             .catch((error) => console.error(error));
             await proyectoService.GetProyectosDatosGeneralesByIdProyecto(idProy,token)
             .then((data) => {
                //console.log(data);
                setProyectoDatosGenerales(data)
             })               
             .catch((error) => console.error(error));                         
        }catch(error){
          console.error('Error:',error);
        }
        setReady(true);
    };
    function setProducto(data: any) {
        //console.log(data);
        setDatosProducto({
            ...datosProducto,
            producto: setProductoTerminado(data.data.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.data.motivo) as TblDecInvMotivoProdTermin,
            colProducto: setListProductoColaborador(data.data.colProducto) as Array<ProductoColaboradorDTO>
        });
        tengoAcceso(data.data.motivo.idpersona);
        //console.log(datosFormulario);
    }
    function setProyectoDatosGenerales(data: any) {
        //console.log(data);
        setDatosGeneralProy({
            ...datosGeneralProy,
            datosGenerales: setDatosGenerales(data.data.datosGenerales) as DatosGenerales,
            idInvestigador: user.idinv,
            objEspecificos: [],
            objODS:[],
        });
    }
    const goToNavigation = (site:string) =>{
        history(site)
    }
    function tengoAcceso(idmotivocrea:number) {
        //console.log(data);
        //console.log(user);
        let idinvestigador:number = user.idpersona;
        if(usuarioService.authorizedByRol(144,user.roles) || usuarioService.authorizedByRol(142,user.roles)){
        //if(roles.includes('ANALISTA DE GESTIÓN DE PROYECTOS') || roles.includes('ADMINISTRADOR')){
            setPuedo(true);
            setIdcreador(idmotivocrea);
        }else if(idmotivocrea == idinvestigador){
            setPuedo(true);
            setIdcreador(idinvestigador);
        }
    }
    //#endregion
    //#region Interaccion
    const handleResponse = async (responseData: ProductoColaboradorDTO) => {
        // Manejar la respuesta aquí
        //console.log(responseData);
        alertaService.alertaExito("Éxito","Se agregó al colaborador de forma exitosa. En unos segundos se recargará la página.") ;
        if(responseData.iddecinvproyecto > 0){
           var obt:EmailModel = GetVoidEmailModel();
           obt.asunto = 'Notificación de colaboración proyecto';
           obt.to = user.emailAddress;
           obt.ccsAddreses.push(responseData.email);
           obt.texto = 'Se le notifica que ha sido ingresado como colaborador del proyecto '+datosGeneralProy.datosGenerales.titulo+' a las ' + format(new Date(),"MMMM dd, yyyy HH:mm:ss");
           const resp = await emailService.MailNotificacion(obt,token); 
        } 
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };   
    //#endregion
    return(
        <Container sx={{mt:2, mb:4}}>
            <br />
            {auth ? 
            <>{ready ? 
            <Grid>
                <Typography variant="h4" gutterBottom><strong>Agregar Colaborador Producto</strong></Typography>
                <Alert icon={<FaUserPlus fontSize="inherit" />} severity="info">
                    <Typography variant="subtitle1" gutterBottom><strong>{datosProducto.producto.titulo}</strong></Typography>
                </Alert> 
                <br />              
                {puedo 
                ?
                <>
                <ColProductoForm 
                    idproducto={datosProducto.producto.iddecinvproyectoprodtermin}
                    idtipoproducto={datosProducto.producto.iddecinvtipoproductoesperado} 
                    idproyecto={datosProducto.producto.iddecinvproyecto}
                    titulo={datosGeneralProy.datosGenerales.titulo}
                    fechainicio={datosGeneralProy.datosGenerales.fechainicio}
                    fechafin={datosGeneralProy.datosGenerales.fechafin}
                    colaborador={datosColaborador}
                    colProducto={datosProducto.colProducto}
                    idinvestigador={datosProducto.motivo.idpersona}
                    token={user.token}
                    onResponse={handleResponse}
                />
                <br />
                <TableColProducto  listColaboradores={datosProducto.colProducto} token={token} ready={ready} idinvestigador={user.idinv}/>
                </>
                :
                <Alert icon={<MdDoNotDisturbAlt fontSize="inherit" />} severity="error">
                    <Typography variant="subtitle1" gutterBottom>Lo sentimos, actualmente no tienes acceso a esta opción. Por favor, ponte en contacto con el administrador del sistema para obtener más información o para solicitar permisos adicionales.</Typography>
                </Alert> 
                }
            </Grid>
            :
            <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
                <LinearProgress color="secondary" />
            </Stack>}
          </>
          :
          <UnauthorizedPage />
          }
        </Container>
    );
}

